"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var TreatNullValuesAsZeroCheckbox = function (_a) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, onChange = _a.onChange, intl = _a.intl;
    var handleOnChange = function (e) { return onChange(e.target.checked); };
    return (react_1.default.createElement("label", { className: "input-checkbox-label gd-mvf-treat-null-values-as-zero s-treat-null-values-as-zero" },
        react_1.default.createElement("input", { type: "checkbox", name: "treat-null-values-as", className: "input-checkbox", checked: checked, onChange: handleOnChange }),
        react_1.default.createElement("span", { className: "input-label-text" },
            intl.formatMessage({ id: "mvf.treatNullValuesAsZeroLabel" }),
            react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { showDelay: 400, hideDelay: 200 },
                react_1.default.createElement("span", { className: "inlineBubbleHelp" }),
                react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary", alignPoints: [{ align: "tc bl" }] }, intl.formatMessage({ id: "mvf.treatNullValuesAsZeroTooltip" }))))));
};
exports.default = TreatNullValuesAsZeroCheckbox;
//# sourceMappingURL=TreatNullValuesAsZeroCheckbox.js.map